import MarketAccountDropdown from "./MarketAccountDropdown";

const UserDropdown = () => <MarketAccountDropdown variant="desktop" />;

export default UserDropdown;
